import { Group, InputWrapper, InputWrapperProps } from "@mantine/core"
import { useSuspenseQueryGet } from "../../typed-client/hooks/use-suspense-query-get"
import { RangePickerMakroProps } from "."
import { useTranslation } from "react-i18next"
import { DatePickerMakroChip } from "./datepicker-makro-chip"

interface Props extends RangePickerMakroProps, InputWrapperProps {}

export function SeasonQuickSelectMakro({
  start,
  end,
  setStart,
  setEnd,
  ...props
}: Props) {
  const { data: seasons } = useSuspenseQueryGet(
    "/api/Season/GetQuickSelectSeasons",
    null
  )

  const [t] = useTranslation("app_server")

  return (
    <InputWrapper label={t("SeasonQuickSelect")} {...props}>
      <Group gap="xs">
        {seasons.map((season) => (
          <DatePickerMakroChip
            key={season.seasonId}
            variant="filled"
            children={season.name}
            targetStart={new Date(season.startDate)}
            targetEnd={new Date(season.endDate)}
            start={start}
            end={end}
            setEnd={setEnd}
            setStart={setStart}
          />
        ))}
      </Group>
    </InputWrapper>
  )
}
